/**
 * Códigos telefónicos de país (E.164) para el selector de "código de área"
 * en Configuración. A diferencia de MONEDAS (utils/moneda.js, que solo
 * cubre las 16 divisas que el sistema sabe formatear), esta lista cubre
 * todos los países, porque una empresa puede querer mandar recordatorios a
 * clientes en un país cuya moneda no maneja el sistema.
 */
export const CODIGOS_AREA = [
  { codigo: '93', pais: 'Afganistán' },
  { codigo: '355', pais: 'Albania' },
  { codigo: '213', pais: 'Argelia' },
  { codigo: '1684', pais: 'Samoa Americana' },
  { codigo: '376', pais: 'Andorra' },
  { codigo: '244', pais: 'Angola' },
  { codigo: '1264', pais: 'Anguila' },
  { codigo: '1268', pais: 'Antigua y Barbuda' },
  { codigo: '54', pais: 'Argentina' },
  { codigo: '374', pais: 'Armenia' },
  { codigo: '297', pais: 'Aruba' },
  { codigo: '61', pais: 'Australia' },
  { codigo: '43', pais: 'Austria' },
  { codigo: '994', pais: 'Azerbaiyán' },
  { codigo: '1242', pais: 'Bahamas' },
  { codigo: '973', pais: 'Baréin' },
  { codigo: '880', pais: 'Bangladés' },
  { codigo: '1246', pais: 'Barbados' },
  { codigo: '375', pais: 'Bielorrusia' },
  { codigo: '32', pais: 'Bélgica' },
  { codigo: '501', pais: 'Belice' },
  { codigo: '229', pais: 'Benín' },
  { codigo: '1441', pais: 'Bermudas' },
  { codigo: '975', pais: 'Bután' },
  { codigo: '591', pais: 'Bolivia' },
  { codigo: '387', pais: 'Bosnia y Herzegovina' },
  { codigo: '267', pais: 'Botsuana' },
  { codigo: '55', pais: 'Brasil' },
  { codigo: '1284', pais: 'Islas Vírgenes Británicas' },
  { codigo: '673', pais: 'Brunéi' },
  { codigo: '359', pais: 'Bulgaria' },
  { codigo: '226', pais: 'Burkina Faso' },
  { codigo: '257', pais: 'Burundi' },
  { codigo: '855', pais: 'Camboya' },
  { codigo: '237', pais: 'Camerún' },
  { codigo: '1', pais: 'Canadá / EE. UU. / Rep. Dominicana / Caribe' },
  { codigo: '238', pais: 'Cabo Verde' },
  { codigo: '1345', pais: 'Islas Caimán' },
  { codigo: '236', pais: 'República Centroafricana' },
  { codigo: '235', pais: 'Chad' },
  { codigo: '56', pais: 'Chile' },
  { codigo: '86', pais: 'China' },
  { codigo: '57', pais: 'Colombia' },
  { codigo: '269', pais: 'Comoras' },
  { codigo: '243', pais: 'Rep. Democrática del Congo' },
  { codigo: '242', pais: 'Congo' },
  { codigo: '682', pais: 'Islas Cook' },
  { codigo: '506', pais: 'Costa Rica' },
  { codigo: '385', pais: 'Croacia' },
  { codigo: '53', pais: 'Cuba' },
  { codigo: '357', pais: 'Chipre' },
  { codigo: '420', pais: 'República Checa' },
  { codigo: '45', pais: 'Dinamarca' },
  { codigo: '253', pais: 'Yibuti' },
  { codigo: '1767', pais: 'Dominica' },
  { codigo: '1809', pais: 'República Dominicana' },
  { codigo: '593', pais: 'Ecuador' },
  { codigo: '20', pais: 'Egipto' },
  { codigo: '503', pais: 'El Salvador' },
  { codigo: '240', pais: 'Guinea Ecuatorial' },
  { codigo: '291', pais: 'Eritrea' },
  { codigo: '372', pais: 'Estonia' },
  { codigo: '251', pais: 'Etiopía' },
  { codigo: '500', pais: 'Islas Malvinas' },
  { codigo: '298', pais: 'Islas Feroe' },
  { codigo: '679', pais: 'Fiyi' },
  { codigo: '358', pais: 'Finlandia' },
  { codigo: '33', pais: 'Francia' },
  { codigo: '594', pais: 'Guayana Francesa' },
  { codigo: '689', pais: 'Polinesia Francesa' },
  { codigo: '241', pais: 'Gabón' },
  { codigo: '220', pais: 'Gambia' },
  { codigo: '995', pais: 'Georgia' },
  { codigo: '49', pais: 'Alemania' },
  { codigo: '233', pais: 'Ghana' },
  { codigo: '350', pais: 'Gibraltar' },
  { codigo: '30', pais: 'Grecia' },
  { codigo: '299', pais: 'Groenlandia' },
  { codigo: '1473', pais: 'Granada' },
  { codigo: '590', pais: 'Guadalupe' },
  { codigo: '1671', pais: 'Guam' },
  { codigo: '502', pais: 'Guatemala' },
  { codigo: '224', pais: 'Guinea' },
  { codigo: '245', pais: 'Guinea-Bisáu' },
  { codigo: '592', pais: 'Guyana' },
  { codigo: '509', pais: 'Haití' },
  { codigo: '504', pais: 'Honduras' },
  { codigo: '852', pais: 'Hong Kong' },
  { codigo: '36', pais: 'Hungría' },
  { codigo: '354', pais: 'Islandia' },
  { codigo: '91', pais: 'India' },
  { codigo: '62', pais: 'Indonesia' },
  { codigo: '98', pais: 'Irán' },
  { codigo: '964', pais: 'Irak' },
  { codigo: '353', pais: 'Irlanda' },
  { codigo: '972', pais: 'Israel' },
  { codigo: '39', pais: 'Italia' },
  { codigo: '1876', pais: 'Jamaica' },
  { codigo: '81', pais: 'Japón' },
  { codigo: '962', pais: 'Jordania' },
  { codigo: '7', pais: 'Kazajistán / Rusia' },
  { codigo: '254', pais: 'Kenia' },
  { codigo: '686', pais: 'Kiribati' },
  { codigo: '965', pais: 'Kuwait' },
  { codigo: '996', pais: 'Kirguistán' },
  { codigo: '856', pais: 'Laos' },
  { codigo: '371', pais: 'Letonia' },
  { codigo: '961', pais: 'Líbano' },
  { codigo: '266', pais: 'Lesoto' },
  { codigo: '231', pais: 'Liberia' },
  { codigo: '218', pais: 'Libia' },
  { codigo: '423', pais: 'Liechtenstein' },
  { codigo: '370', pais: 'Lituania' },
  { codigo: '352', pais: 'Luxemburgo' },
  { codigo: '853', pais: 'Macao' },
  { codigo: '389', pais: 'Macedonia del Norte' },
  { codigo: '261', pais: 'Madagascar' },
  { codigo: '265', pais: 'Malaui' },
  { codigo: '60', pais: 'Malasia' },
  { codigo: '960', pais: 'Maldivas' },
  { codigo: '223', pais: 'Malí' },
  { codigo: '356', pais: 'Malta' },
  { codigo: '692', pais: 'Islas Marshall' },
  { codigo: '596', pais: 'Martinica' },
  { codigo: '222', pais: 'Mauritania' },
  { codigo: '230', pais: 'Mauricio' },
  { codigo: '52', pais: 'México' },
  { codigo: '691', pais: 'Micronesia' },
  { codigo: '373', pais: 'Moldavia' },
  { codigo: '377', pais: 'Mónaco' },
  { codigo: '976', pais: 'Mongolia' },
  { codigo: '382', pais: 'Montenegro' },
  { codigo: '1664', pais: 'Montserrat' },
  { codigo: '212', pais: 'Marruecos' },
  { codigo: '258', pais: 'Mozambique' },
  { codigo: '95', pais: 'Myanmar' },
  { codigo: '264', pais: 'Namibia' },
  { codigo: '674', pais: 'Nauru' },
  { codigo: '977', pais: 'Nepal' },
  { codigo: '31', pais: 'Países Bajos' },
  { codigo: '687', pais: 'Nueva Caledonia' },
  { codigo: '64', pais: 'Nueva Zelanda' },
  { codigo: '505', pais: 'Nicaragua' },
  { codigo: '227', pais: 'Níger' },
  { codigo: '234', pais: 'Nigeria' },
  { codigo: '683', pais: 'Niue' },
  { codigo: '850', pais: 'Corea del Norte' },
  { codigo: '47', pais: 'Noruega' },
  { codigo: '968', pais: 'Omán' },
  { codigo: '92', pais: 'Pakistán' },
  { codigo: '680', pais: 'Palaos' },
  { codigo: '970', pais: 'Palestina' },
  { codigo: '507', pais: 'Panamá' },
  { codigo: '675', pais: 'Papúa Nueva Guinea' },
  { codigo: '595', pais: 'Paraguay' },
  { codigo: '51', pais: 'Perú' },
  { codigo: '63', pais: 'Filipinas' },
  { codigo: '48', pais: 'Polonia' },
  { codigo: '351', pais: 'Portugal' },
  { codigo: '1787', pais: 'Puerto Rico' },
  { codigo: '974', pais: 'Catar' },
  { codigo: '262', pais: 'Reunión' },
  { codigo: '40', pais: 'Rumania' },
  { codigo: '250', pais: 'Ruanda' },
  { codigo: '1869', pais: 'San Cristóbal y Nieves' },
  { codigo: '1758', pais: 'Santa Lucía' },
  { codigo: '508', pais: 'San Pedro y Miquelón' },
  { codigo: '1784', pais: 'San Vicente y las Granadinas' },
  { codigo: '685', pais: 'Samoa' },
  { codigo: '378', pais: 'San Marino' },
  { codigo: '239', pais: 'Santo Tomé y Príncipe' },
  { codigo: '966', pais: 'Arabia Saudita' },
  { codigo: '221', pais: 'Senegal' },
  { codigo: '381', pais: 'Serbia' },
  { codigo: '248', pais: 'Seychelles' },
  { codigo: '232', pais: 'Sierra Leona' },
  { codigo: '65', pais: 'Singapur' },
  { codigo: '421', pais: 'Eslovaquia' },
  { codigo: '386', pais: 'Eslovenia' },
  { codigo: '677', pais: 'Islas Salomón' },
  { codigo: '252', pais: 'Somalia' },
  { codigo: '27', pais: 'Sudáfrica' },
  { codigo: '82', pais: 'Corea del Sur' },
  { codigo: '211', pais: 'Sudán del Sur' },
  { codigo: '34', pais: 'España' },
  { codigo: '94', pais: 'Sri Lanka' },
  { codigo: '249', pais: 'Sudán' },
  { codigo: '597', pais: 'Surinam' },
  { codigo: '268', pais: 'Esuatini' },
  { codigo: '46', pais: 'Suecia' },
  { codigo: '41', pais: 'Suiza' },
  { codigo: '963', pais: 'Siria' },
  { codigo: '886', pais: 'Taiwán' },
  { codigo: '992', pais: 'Tayikistán' },
  { codigo: '255', pais: 'Tanzania' },
  { codigo: '66', pais: 'Tailandia' },
  { codigo: '670', pais: 'Timor Oriental' },
  { codigo: '228', pais: 'Togo' },
  { codigo: '676', pais: 'Tonga' },
  { codigo: '1868', pais: 'Trinidad y Tobago' },
  { codigo: '216', pais: 'Túnez' },
  { codigo: '90', pais: 'Turquía' },
  { codigo: '993', pais: 'Turkmenistán' },
  { codigo: '1649', pais: 'Islas Turcas y Caicos' },
  { codigo: '688', pais: 'Tuvalu' },
  { codigo: '256', pais: 'Uganda' },
  { codigo: '380', pais: 'Ucrania' },
  { codigo: '971', pais: 'Emiratos Árabes Unidos' },
  { codigo: '44', pais: 'Reino Unido' },
  { codigo: '598', pais: 'Uruguay' },
  { codigo: '998', pais: 'Uzbekistán' },
  { codigo: '678', pais: 'Vanuatu' },
  { codigo: '58', pais: 'Venezuela' },
  { codigo: '84', pais: 'Vietnam' },
  { codigo: '681', pais: 'Wallis y Futuna' },
  { codigo: '967', pais: 'Yemen' },
  { codigo: '260', pais: 'Zambia' },
  { codigo: '263', pais: 'Zimbabue' },
].sort((a, b) => a.pais.localeCompare(b.pais, 'es'));
